import checkImage from "../assets/images/checkImage.jpeg";
export const payers = [
  "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
  "Aamir Khan (Eagle) - test1 - 912 n creek dr edmond, OK 73034",
  "Aspire Premier Properties - 5018 Quell Ct. Woodbridge, VA 22193",
  "Sitafa and Jevon Gill - 5018 Quell Court Woodbridge, VA 22193",
];

export const payees = [
  {
    value:
      "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
  },
  {
    value: "Aamir Khan (Eagle) - test1 - 912 n creek dr edmond, OK 73034",
  },
  {
    value: "Aspire Premier Properties - 5018 Quell Ct. Woodbridge, VA 22193",
  },
  {
    value: "Sitafa and Jevon Gill - 5018 Quell Court Woodbridge, VA 22193",
  },
];

export const glAccounts = [
 
  { key: "grossPotentialRent", title: "Gross Potential Rent", value: "Gross Potential Rent" },
  { key: "insuranceServices", title: "Insurance Services", value: "Insurance Services" },
  { key: "integrityLeaseBreakFee", title: "Integrity Lease Break Fee", value: "Integrity Lease Break Fee" },
  { key: "clearingAccount", title: "Clearing Account", value: "Clearing Account" },
  { key: "ownerHeldSd", title: "Owner Held Sd", value: "Owner Held Sd" },

];

export const glAccountss = [
  {
    label: "Income",
    value: "Income",
    children: [
      { title: "Gross Potential Rent", value: "Gross Potential Rent" },
      { title: "Insurance Services", value: "Insurance Services" },
      {
        title: "Integrity Lease Break Fee",
        value: "Integrity Lease Break Fee",
      },
    ],
  },
  {
    label: "Liability",
    value: "Liability",
    children: [
      {
        title: "Clearing Account",
        value: "Clearing Account",
      },
      {
        title: "Owner Held Sd",
        value: "Owner Held Sd",
      },
    ],
  },
];

export const receiptsTableData = [
  {
    key: "1",
    date: "01/27/2023",
    payer: "Stephanie Suazo (Paid online)",
    glAccount: "118: Prepayments",
    propertyUnit: "1904 Lullaby Lane",
    amount: "823.00",
    reference: "1131-0D50",
    unit: "--",
    remarks: "--",
    cashAccount: "23291: Rental Income Account",
    bankDeposit: "Automatic Deposit Pending",
    account: [
      {
        gLAccount: "Tenant Benefit Package - New",
        description: "March 2013",
        amount: "100",
      },
      {
        gLAccount: "Rent Income",
        description: "March 2013",
        amount: "200",
      },
    ],
  },
  {
    key: '2',
    date: "01/26/2023",
    payer: "Angela S. Lamka-West (Paid online)",
    glAccount:
      "116: Tenant Benefit Package - New, 997: Eviction Notice Fee, 103: Rent Income, 118: Prepayments",
    propertyUnit: "9626 SE 4th",
    amount: "500.00",
    reference: "5AF5-4FD0",
    unit: "--",
    remarks: "--",
    cashAccount: "23291: Rental Income Account",
    bankDeposit: "Automatic Deposit Pending",
    account: [
      {
      
        gLAccount: "Rent Income",
        description: "March 2013",
        amount: "200",
      },
    ],
  },
];

export const chargesTableData = [
  {
    key: "1",
    payer: "Michel Soto",
    glAccount: "23287: Repairs",
    propertyUnit: "1605 Symphony Lane",
    chargeDate: "01/19/2023",
    amount: "145.00",
    status: "Unpaid",
    tenantCharge: {
      tenant: "Angela S. Lamka-West",
      totalAmount: "300.00",
      amountPaid: "0.00",
      postingDate: "03/02/2023",
      property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
      unit: "--",
      description: "--",
      paymentPlan: "No",
    },
  },
  {
    key: "2",
    payer: "Christopher A. Davis",
    glAccount: "997: Eviction Notice Fee",
    propertyUnit: "1817 Treat Drive",
    chargeDate: "01/12/2023",
    amount: "35.00",
    status: "Unpaid",
    tenantCharge: {
      tenant: "Angela S. Lamka-West",
      totalAmount: "300.00",
      amountPaid: "0.00",
      postingDate: "03/02/2023",
      property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
      unit: "--",
      description: "--",
      paymentPlan: "No",
    },
  },
  {
    key: "3",

    payer: "Michel Soto",
    glAccount: "23287: Repairs",
    propertyUnit: "1605 Symphony Lane",
    chargeDate: "01/19/2023",
    amount: "145.00",
    status: "Unpaid",
    tenantCharge: {
      tenant: "Angela S. Lamka-West",
      totalAmount: "300.00",
      amountPaid: "0.00",
      postingDate: "03/02/2023",
      property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
      unit: "--",
      description: "--",
      paymentPlan: "No",
    },
  },
  {
    key: "4",

    payer: "Christopher A. Davis",
    glAccount: "997: Eviction Notice Fee",
    propertyUnit: "1817 Treat Drive",
    chargeDate: "01/12/2023",
    amount: "35.00",
    status: "Unpaid",
    tenantCharge: {
      tenant: "Angela S. Lamka-West",
      totalAmount: "300.00",
      amountPaid: "0.00",
      postingDate: "03/02/2023",
      property: "9626 SE 4th - 9626 SE 4th Midwest City, OK 73130",
      unit: "--",
      description: "--",
      paymentPlan: "No",
    },
  },
];

export const bankDepositsTableData = [
  {
    key: "1",

    depositDate: "01/30/2023",
    bankAccount: "Rental Income Account",
    depositNumber: "Automatic Deposit",
    propertyUnit:
      "4208 N. Redmond, 3316 NW 43rd St., 3021 NW 13th Street, 127 SW 45th, 4508 N. Redmond Ave, ...",
    originalAmount: "6,299.95",
    updatedAmount: "6,299.95",
    depositItems: [
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
    ],
    deposit: {
      bankName: "Liberty National Bank",
      accountName: "Rental Income Account",
      accountNumber: "XXXXXXXX",
      description: "--",
      depositNumber: "Automatic ACH Deposit",
      depositDate: "02/28/2023",
      submissionDate: "03/07/2023",
      numberofItems: "136",
    },
  },
  {
    key: "2",

    depositDate: "01/24/2023",
    bankAccount: "Rental Income Account",
    depositNumber: "Automatic ACH Deposit",
    propertyUnit:
      "1110 Sequoyah Trail, 9723 NE 3rd Pl, 547 East Grumman Drive, 1600 NW 46th St. Unit E",
    originalAmount: "2,384.00",
    updatedAmount: "2,384.00",
    depositItems: [
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
      {
        reference: "0082-40F0",
        date: "03/01/2023",
        property: "7215 N. Macarthur Blvd.- Cherokee Hill Apartments",
        from: "Robert K. Cole",
        description: "--",
        amount: "558.00",
      },
      {
        reference: "017D-CCC0",
        date: "03/01/2023",
        property: "602 W. Shadow Ridge Way",
        from: "Anna M. OSteen",
        description: "Reversed by NSF",
        amount: "505.00",
      },
    ],
    deposit: {
      bankName: "Liberty National Bank",
      accountName: "Rental Income Account",
      accountNumber: "XXXXXXXX",
      description: "--",
      depositNumber: "Automatic ACH Deposit",
      depositDate: "02/28/2023",
      submissionDate: "03/07/2023",
      numberofItems: "136",
    },
  },
];

export const bankCompletedTransfers = [
  {
    id: 1,
    transfers: "23",
    transferredDate: "10/28/2022",
    transferredFrom: "Security Deposit",
    transferredTo: "Rental Income Account",
    amount: "16,356.00",
    createdDate: "",
    transfersIncluded: [
      {
        id: 1,
        amount: "474.00",
        transfer: "3000 N. Viewpoint Dr.",
        moveOut:
          "Jaquetta R. Armstrong, Jalise Adams, Shamaya Adams, Monica R. Armstrong, and Shaquetta A. Armstrong",
        completed: true,
      },
      {
        id: 2,
        amount: "210.00",
        transfer: "3232 S. Madole Blvd - House",
        moveOut: "Anthony B. Chatham and Randall L. Dovers",
        completed: true,
      },
      {
        id: 3,
        amount: "85.00",
        transfer: "3232 S. Madole Blvd - Upper",
        moveOut: "Parker C. Johnson and Porsha M. Keller",
        completed: true,
      },
      {
        id: 4,
        amount: "825.00",
        transfer: "4200 Altadena Ave",
        moveOut: "Kelsey Hodges and Antonio McGuire",
        completed: true,
      },
    ],
    auditLog: [
      {
        date: "10/28/2022 12:49 PM",
        TransferAmount: "16,356.00",
        recieverTitle: "Rhett Tullis",
        incompleteTransferDate: "",
        incompleteTransferAmount: "",
        incompleteRecieverTitle: "",
        canceledTransferDate: "",
        canceledTransferAmount: "",
        canceledRecieverTitle: "",
      },
    ],
    completed: true,
  },
  {
    id: 2,
    transfers: "1817 Treat Drive",
    transferredDate: "04/01/2021",
    transferredFrom: "Security Deposit",
    transferredTo: "Rental Income Account",
    amount: "405.00",
    createdDate: "03/03/2021",
    transfersIncluded: [],
    auditLog: [
      {
        date: "04/01/2021 04:21 PM",
        TransferAmount: "405.00",
        recieverTitle: "Rhett Tullis",
        incompleteTransferDate: "03/03/2021 12:11 PM",
        incompleteTransferAmount: "405.00",
        incompleteRecieverTitle: "Rhett Tullis",
        canceledTransferDate: "",
        canceledTransferAmount: "",
        canceledRecieverTitle: "",
      },
    ],
    completed: true,
  },
  {
    id: 3,
    transfers: "1817 Treat Drive",
    transferredDate: "",
    transferredFrom: "Security Deposit",
    transferredTo: "Rental Income Account",
    amount: "875.00",
    createdDate: "03/03/2021",
    transfersIncluded: [],
    auditLog: [
      {
        date: "",
        TransferAmount: "",
        recieverTitle: "",
        incompleteTransferDate: "03/03/2021 12:09 PM",
        incompleteTransferAmount: "875.00",
        incompleteRecieverTitle: "Rhett Tullis",
        canceledTransferDate: "03/03/2021 12:09 PM",
        canceledTransferAmount: "875.00",
        canceledRecieverTitle: "Rhett Tullis",
      },
    ],
    completed: false,
  },
];

export const paymentBatchesData = [
  {
    id: 1,
    preparedOn: "01/25/2023",
    preparedBy: "Rhett Tullis",
    totalAmount: "$1,303.05",
  },
  {
    id: 2,
    preparedOn: "01/05/2023",
    preparedBy: "Rhett Tullis",
    totalAmount: "$69,944.58",
  },
];

export const paymentsData = [
  {
    id: 1,
    key: "1",
    checkImage: checkImage,
    payments: [
      {
        property:
          "201 Three Oaks Dr. - 201 Three Oaks DrMidwest City, OK 73130",
        unit: "",
        account: "23287: Repairs",
        amount: "$745.00",
        description: "Pressure test 201 Three oaks",
      },
      {
        property:
          "3200 NW 67th Street - 3200 NW 67th Street Oklahoma City, OK 73116",
        unit: "",
        account: "23287: Repairs",
        amount: "$486.06",
        description: "Plumber",
      },
      {
        property:
          "929 NE 32nd Street - 929 NE 32nd Street Oklahoma City, OK 73105",
        unit: "",
        account: "23287: Repairs",
        amount: "$1,034.75",
        description: "Plumber",
      },
      {
        property:
          "201 Three Oaks Dr. - 201 Three Oaks Dr Midwest City, OK 73130",
        unit: "",
        account: "23287: Repairs",
        amount: "$745.00",
        description: " Pressure test 201 Three oaks",
      },
      {
        property:
          "3200 NW 67th Street - 3200 NW 67th Street Oklahoma City, OK 73116",
        unit: "",
        account: "23287: Repairs",
        amount: "$486.06",
        description: "Plumber",
      },
      {
        property:
          "929 NE 32nd Street - 929 NE 32nd Street Oklahoma City, OK 73105",
        unit: "",
        account: "23287: Repairs",
        amount: "$1,034.75",
        description: "Plumber",
      },
    ],
    date: "01/19/2023",
    payee: "Tyler Weddle",
    bankAccount: "Rental Income Account",
    reference: "ACH 23BF-AAB0",
    amount: "1,770.00",
    lastPrinted: "--",
  },
  {
    id: 2,
    key: "2",
    checkImage: checkImage,
    payments: [
      {
        property:
          "201 Three Oaks Dr. - 201 Three Oaks DrMidwest City, OK 73130",
        unit: "",
        account: "23287: Repairs",
        amount: "$745.00",
        description: " Pressure test 201 Three oaks",
      },
      {
        property:
          "3200 NW 67th Street - 3200 NW 67th Street Oklahoma City, OK 73116",
        unit: "",
        account: "23287: Repairs",
        amount: "$486.06",
        description: "Plumber",
      },
      {
        property:
          "929 NE 32nd Street - 929 NE 32nd StreetOklahoma City, OK 73105",
        unit: "",
        account: "23287: Repairs",
        amount: "$1,034.75",
        description: "Plumber",
      },
    ],
    date: "01/19/2023",
    payee: "Brothers and Sons Heat and Air",
    bankAccount: "Rental Income Account",
    reference: "ACH 23C3-82E8",
    amount: "37,590.00",
    lastPrinted: "--",
  },
  {
    id: 3,
    key: "3",
    checkImage: checkImage,
    payments: [
      {
        property:
          "201 Three Oaks Dr. - 201 Three Oaks Dr Midwest City, OK 73130",
        unit: "",
        account: "23287: Repairs",
        amount: "$745.00",
        description: " Pressure test 201 Three oaks",
      },
      {
        property:
          "3200 NW 67th Street - 3200 NW 67th Street Oklahoma City, OK 73116",
        unit: "",
        account: "23287: Repairs",
        amount: "$486.06",
        description: "Plumber",
      },
      {
        property:
          "929 NE 32nd Street - 929 NE 32nd Street Oklahoma City, OK 73105",
        unit: "",
        account: "23287: Repairs",
        amount: "$1,034.75",
        description: "Plumber",
      },
      {
        property:
          "201 Three Oaks Dr. - 201 Three Oaks Dr Midwest City, OK 73130",
        unit: "",
        account: "23287: Repairs",
        amount: "$745.00",
        description: " Pressure test 201 Three oaks",
      },
      {
        property:
          "3200 NW 67th Street - 3200 NW 67th Street Oklahoma City, OK 73116",
        unit: "",
        account: "23287: Repairs",
        amount: "$486.06",
        description: "Plumber",
      },
      {
        property:
          "929 NE 32nd Street - 929 NE 32nd Street Oklahoma City, OK 73105",
        unit: "",
        account: "23287: Repairs",
        amount: "$1,034.75",
        description: "Plumber",
      },
    ],
    date: "01/19/2023",
    payee: "Tyler Weddle",
    bankAccount: "Rental Income Account",
    reference: "ACH 23BF-AAB0",
    amount: "1,770.00",
    lastPrinted: "01/19/2023",
  },
];

export const billsAllData = [
  {
    id: 1,
    payee: "Kennedy Law Firm",
    reference: "IO-012623-10",
    billDate: "01/27/2023",
    for: "9626 SE 4th",
    glAccount: "23280: Legal and Professional Fees",
    dueDate: "01/27/2023",
    amount: "200.00",
    status: "Unpaid",
    approvalStatus: "In Progress",
    remarks: "February 2023",
    memoForCheck: "--",
    postingDate: "02/22/2023",
    currentApprovalStep: "1 / 1",
    lastApprovedBy: "--",
    cashAccount: "23291: Rental Income Account",
    nextAprrovers: [
      "Kendra Mcguire (User)",
      "Yamile Tullis (User)",
      "Gerson Ayala (User)",
      "Rhett Tullis (User)",
    ],
    payments: [
      {
        property: "test1 - 912 n creek dredmond, OK 73034",
        unit: "--",
        glAccount: "107: Accounts Payable",
        description: "",
        amount: "10.00",
        status: "Unpaid",
        payDate: "--",
      },
    ],
    auditLogs: [{}],
  },
  {
    id: 2,
    payee: "Kennedy Law Firm",
    reference: "IO-012623-6",
    billDate: "01/27/2023",
    for: "1817 Treat Drive",
    glAccount: "23280: Legal and Professional Fees",
    dueDate: "01/27/2023",
    amount: "175.00",
    status: "Unpaid",
    remarks: "--",
    memoForCheck: "Repairs 1817 Treat Dr",
    postingDate: "02/21/2023",
    currentApprovalStep: "1 / 1",
    lastApprovedBy: "--",
    cashAccount: "23291: Rental Income Account",
    nextAprrovers: [
      "Kendra Mcguire (User)",
      "Yamile Tullis (User)",
      "Gerson Ayala (User)",
    ],
    payments: [
      {
        property: "1817 Treat Drive - Midwest City, OK 73110",
        unit: "--",
        glAccount: "23287: Repairs",
        description: "Repairs 1817 Treat Dr",
        amount: "175.00",
        status: "Unpaid",
        payDate: "--",
      },
    ],
    auditLogs: [{}],
  },
];

export const billsApprovedData = [
  {
    id: 1,
    payee: "Kennedy Law Firm",
    reference: "IO-012623-10",
    billDate: "01/27/2023",
    for: "9626 SE 4th",
    glAccount: "23280: Legal and Professional Fees",
    dueDate: "01/27/2023",
    amount: "200.00",
    status: "Unpaid",
  },
  {
    id: 2,
    payee: "Kennedy Law Firm",
    reference: "IO-012623-6",
    billDate: "01/27/2023",
    for: "1817 Treat Drive",
    glAccount: "23280: Legal and Professional Fees",
    dueDate: "01/27/2023",
    amount: "175.00",
    status: "Unpaid",
  },
  {
    id: 3,
    payee: "Kennedy Law Firm",
    reference: "IO-012623-10",
    billDate: "01/27/2023",
    for: "9626 SE 4th",
    glAccount: "23280: Legal and Professional Fees",
    dueDate: "01/27/2023",
    amount: "200.00",
    status: "Unpaid",
  },
];

export const billsPendingData = [];
export const billsOnHoldData = [];

export const glAccountDetails = [
  {
    id: 1,
    number: "--",
    accountName: "Opening Balance Equity",
    accountType: "Capital",
    subAccountOf: "--",
    fundAccount: "Operating",
    offSetAccount: "23291: Rental Income Account",
    managementFees: "No",
    reporting: "No",
    cashFlow: "Yes",
  },
  {
    id: 2,
    number: "--",
    accountName: "Clearing Account",
    accountType: "Liability",
    subAccountOf: "--",
    fundAccount: "Operating",
    offSetAccount: "23291: Rental Income Account",
    managementFees: "No",
    reporting: "No",
    cashFlow: "Yes",
  },
  {
    id: 3,
    number: "--",
    accountName: "Commissions/Placement Fees",
    accountType: "Expense",
    subAccountOf: "--",
    fundAccount: "Operating",
    offSetAccount: "23291: Rental Income Account",
    managementFees: "No",
    reporting: "No",
    cashFlow: "Yes",
  },
  {
    id: 4,
    number: "--",
    accountName: "Delinquency",
    accountType: "Income",
    subAccountOf: "--",
    fundAccount: "Operating",
    offSetAccount: "23291: Rental Income Account",
    managementFees: "No",
    reporting: "No",
    cashFlow: "No",
  },
];

export const recurringBills = [
  {
    id: 1,
    key: 1,
    payee: "test",
    glAccount: "107: Accounts Payable",
    propertyUnit: "test 2",
    lastBilledOn: "Feb 2023",
    postCode: "--",
    amount: "5.00",
    repeats: "Never (Must Post Manually)",
    remarks: "--",
    startDate: "02/22/2023",
    endDate: "03/22/2023",
    memoOnCheck: "--",
    billDay: "1",
    dueDay: "1",
    recurringBills: [
      {
        property: "test 2 - 1800 canyon park circle edmond, OK 73013",
        unit: "--",
        account: "Accounts Payable",
        description: "--",
        amount: "5.00",
      },
      {
        property: "test 2 - 1800 canyon park circle edmond, OK 73013",
        unit: "--",
        account: "Accounts Payable",
        description: "--",
        amount: "5.00",
      },
    ],
    recentlyPostedBills: [
      {
        billDate: "02/22/2023",
        dueDate: "03/01/2023",
        amount: "5.00",
        status: "Unpaid",
      },
      {
        billDate: "02/22/2023",
        dueDate: "03/01/2023",
        amount: "5.00",
        status: "Unpaid",
      },
    ],
  },
  {
    id: 2,
    key: 2,
    payee: "test test",
    glAccount: "107: Accounts Payable",
    propertyUnit: "test 1",
    lastBilledOn: "Feb 2023",
    postCode: "--",
    amount: "10.00",
    repeats: "Never (Must Post Manually)",
    remarks: "--",
    startDate: "02/22/2023",
    endDate: "03/22/2023",
    memoOnCheck: "--",
    billDay: "1",
    dueDay: "1",
    recurringBills: [
      {
        property: "test 2 - 1800 canyon park circle edmond, OK 73013",
        unit: "--",
        account: "Accounts Payable",
        description: "--",
        amount: "5.00",
      },
      {
        property: "test 2 - 1800 canyon park circle edmond, OK 73013",
        unit: "--",
        account: "Accounts Payable",
        description: "--",
        amount: "5.00",
      },
    ],
    recentlyPostedBills: [
      {
        billDate: "02/22/2023",
        dueDate: "03/01/2023",
        amount: "5.00",
        status: "Unpaid",
      },
      {
        billDate: "02/22/2023",
        dueDate: "03/01/2023",
        amount: "5.00",
        status: "Unpaid",
      },
    ],
  },
];

for (let i = 5; i <= 20; i++) {
  glAccountDetails.push({
    id: i,
    number: "--",
    accountName: "Delinquency",
    accountType: "Income",
    subAccountOf: "--",
    fundAccount: "Operating",
    offSetAccount: "23291: Rental Income Account",
    managementFees: "No",
    reporting: "No",
    cashFlow: "No",
  });
}

export const tenants = [
  {
    value: "aamir",
  },
  {
    value: "seerat",
  },
  {
    value: "akash",
  },
  {
    value: "kashif",
  },
  {
    value: "kainat",
  },
];

export const selectData = [
  {
    value: "test 1",
  },
  {
    value: "test 2",
  },
  {
    value: "test 3",
  },
  {
    value: "test 4",
  },
];
